import { Route, Routes } from 'react-router-dom';
import Home from './pages/home_page/Home'
import Shonic from './pages/home_page/Shonic'
import Ardawalika from './pages/home_page/Ardawalika'

function App() {
  return (
    <>
      {/* <Header/>
      <Hero/> */}
      <Routes>
        <Route path="/" element={<Home />}></Route>
        <Route path="/shonic" element={<Shonic />}></Route>
        <Route path="/ardawalika" element={<Ardawalika />}></Route>
      </Routes>
      {/* <Home/> */}
    </>
  );
}

export default App;
